export default __webpack_public_path__ + "static/media/about-9.71df4804.jpg";